import React from "react";

/**
 * A general heading in the application
 *
 * @param {Object} props
 * @param {string} title - The title of the heading
 * @param {string} className - The CSS class applied to the heading
 * @returns {JSX.Element}
 */

export default function Heading({ title, className }) {
  return (
    <>
      <div className={`font-bold text-[#E9B838c6] ${className}`}>{title}</div>
    </>
  );
}
